var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { FlagsModule } from '../flagsModule';
// Load avatar poses.
function loadFlags(config) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // Init flags module.
            yield FlagsModule.init(config);
        }
        catch (err) {
            console.error('Load application flags failed', err);
        }
    });
}
// Load avatar thunk.
export const flagsLoadThunk = createAsyncThunk('flags/load', (config) => {
    return loadFlags(config);
});
const initialState = false;
// Load flags slice.
export const flagsLoadSlice = createSlice({
    name: 'slice/flags/load',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(flagsLoadThunk.fulfilled, () => true);
    },
});
export const selectIsFlagsLoaded = (state) => state.isFlagsLoaded;
export const flagsLoadReducer = flagsLoadSlice.reducer;
